import injectSheet from 'react-jss'
import Confirmation from './Confirmation'
import styles from './Confirmation.styles'

export default injectSheet(styles)(Confirmation)
